module.exports = __webpack_public_path__ + "img/le-prisonnier.6a267e04.png";